/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PlayPauseAcademicProgram from './PlayPauseAcademicProgram';

/**
 * The PlayPausePeriod model module.
 * @module model/PlayPausePeriod
 * @version 1.0
 */
class PlayPausePeriod {
    /**
     * Constructs a new <code>PlayPausePeriod</code>.
     * @alias module:model/PlayPausePeriod
     */
    constructor() { 
        
        PlayPausePeriod.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PlayPausePeriod</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PlayPausePeriod} obj Optional instance to populate.
     * @return {module:model/PlayPausePeriod} The populated <code>PlayPausePeriod</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PlayPausePeriod();

            if (data.hasOwnProperty('postponement_end_date')) {
                obj['postponement_end_date'] = ApiClient.convertToType(data['postponement_end_date'], 'Date');
            }
            if (data.hasOwnProperty('resume_enroll_date')) {
                obj['resume_enroll_date'] = ApiClient.convertToType(data['resume_enroll_date'], 'Date');
            }
            if (data.hasOwnProperty('allow_resume_enroll')) {
                obj['allow_resume_enroll'] = ApiClient.convertToType(data['allow_resume_enroll'], 'Boolean');
            }
            if (data.hasOwnProperty('academic_programs')) {
                obj['academic_programs'] = ApiClient.convertToType(data['academic_programs'], [PlayPauseAcademicProgram]);
            }
        }
        return obj;
    }


}

/**
 * @member {Date} postponement_end_date
 */
PlayPausePeriod.prototype['postponement_end_date'] = undefined;

/**
 * @member {Date} resume_enroll_date
 */
PlayPausePeriod.prototype['resume_enroll_date'] = undefined;

/**
 * @member {Boolean} allow_resume_enroll
 */
PlayPausePeriod.prototype['allow_resume_enroll'] = undefined;

/**
 * @member {Array.<module:model/PlayPauseAcademicProgram>} academic_programs
 */
PlayPausePeriod.prototype['academic_programs'] = undefined;






export default PlayPausePeriod;

